import { render, staticRenderFns } from "./GroupCard.vue?vue&type=template&id=34485119&scoped=true&"
import script from "./GroupCard.vue?vue&type=script&lang=ts&"
export * from "./GroupCard.vue?vue&type=script&lang=ts&"
import style0 from "./GroupCard.vue?vue&type=style&index=0&id=34485119&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34485119",
  null
  
)

export default component.exports